import { render, staticRenderFns } from "./MetadataDialog.vue?vue&type=template&id=8866db26"
import script from "./MetadataDialog.vue?vue&type=script&lang=js"
export * from "./MetadataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports